import ko from 'knockout';

export class UIBlockerWithStepsViewModel {
  constructor({
    steps,
    i18n,
  }) {
    this.currentStatusOrder = ko.observable(0);
    this.steps = steps;
    this.stepText = i18n.get('Import_IndicatorImportStep');
  }
}
